// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about___lycB","about__head":"About_about__head__22fsR","about__desc":"About_about__desc__eGJd2","about__container":"About_about__container__NyKT8"};